import React from 'react';
import { AppRouter } from './router';
import { ErrorBoundary } from './core/error/ErrorBoundary';
import { errorService, ErrorType } from './services/core/errorService';
import './assets/styles/globals.css';

function App() {
  // Set up global error handlers
  React.useEffect(() => {
    // Handle unhandled promise rejections
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      errorService.handleError(event.reason, {
        type: 'unhandled_promise_rejection',
        stack: event.reason?.stack,
      });
    };

    // Handle uncaught errors
    const handleError = (event: ErrorEvent) => {
      errorService.handleError(event.error, {
        type: 'uncaught_error',
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      });
    };

    // Register error callbacks
    const unsubscribeAuth = errorService.onError(ErrorType.AUTHENTICATION, (error) => {
      // Handle authentication errors globally
      console.warn('Authentication error:', error.userMessage);
    });

    const unsubscribeNetwork = errorService.onError(ErrorType.NETWORK, (error) => {
      // Handle network errors globally
      console.warn('Network error:', error.userMessage);
    });

    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      window.removeEventListener('error', handleError);
      unsubscribeAuth();
      unsubscribeNetwork();
    };
  }, []);

  return (
    <ErrorBoundary>
      <AppRouter />
    </ErrorBoundary>
  );
}

export default App;
